import React, { memo, useEffect, useRef } from 'react';

import {
  FACEBOOK_FEED_DEFAULT_HEIGHT,
  FACEBOOK_FEED_DEFAULT_WIDTH,
  FACEBOOK_FEED_MAX_WIDTH,
  FACEBOOK_FEED_MIN_WIDTH,
} from 'src/constants';
import type { FacebookFeedProps } from './facebook-feed.props';

import './facebook-feed.scss';

const FacebookFeed = ({
  height = FACEBOOK_FEED_DEFAULT_HEIGHT,
  href,
  isDeprecatedVersion,
  language = 'en_US',
  width = FACEBOOK_FEED_DEFAULT_WIDTH,
}: FacebookFeedProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetWidth = Math.max(FACEBOOK_FEED_MIN_WIDTH, Math.min(FACEBOOK_FEED_MAX_WIDTH, width));

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://connect.facebook.net/${language}/sdk.js#xfbml=1&version=v19.0`;
    document.body.appendChild(script);

    return () => script.remove();
  }, [language]);

  useEffect(() => {
    const frame = containerRef.current?.querySelector('iframe');
    if (frame) {
      frame.src = frame.src.replace(/&width=\d+/, `&width=${widgetWidth}`);
    }
  }, [widgetWidth]);

  return (
    <div className="facebook-feed" ref={containerRef}>
      <div
        className="facebook-feed__content fb-page"
        data-adapt-container-width="true"
        data-height={height}
        data-hide-cover="true"
        data-href={href}
        data-lazy="true"
        data-show-facepile="false"
        data-small-header="true"
        data-width={widgetWidth}
        style={{ minHeight: height }}
        {...(isDeprecatedVersion ? { 'data-show-posts': true } : { 'data-tabs': 'timeline' })}
      />
    </div>
  );
};

export default memo(FacebookFeed);
